import Vue from 'vue';
import App from './App.vue';
import router from './router';
import VuejsDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './assets/app.css';
import filters from './filters';

import JsonEditor from 'vue-json-edit'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';

import protoManager from './proto-manager';
import versionChecker from './service/version-checker';

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.use(VuejsDialog)
//NOTE: could not make it work otherwise :( Using it in a local component didn't work 
Vue.use(JsonEditor)

Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead);

Vue.config.productionTip = false

Vue.mixin({
  filters: filters
})

Vue.directive(
  'focus',
  {
    inserted(el) {
      el.focus();
    }
  }
);

versionChecker.start();
protoManager.init();

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
